var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"flex justify-between pt-2 w-full"},[_c('span',[_vm._v(_vm._s(_vm.$t('molecules.phone_number_box.label'))+":")]),_vm._v(" "),_c('span',{staticClass:"force-ltr",attrs:{"data-test":"rtr-phone-number"}},[_vm._v(_vm._s(_vm.phoneNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }